/**
 * An "exam in progress" flag.
 *
 * Needed in exactly one place: applying an update reloads the page, and a
 * reload mid-block can swallow answers still sitting in the autosave buffer.
 * While an exam is running, a new version waits.
 *
 * Deliberately not a React context — the service-worker code that reads it
 * lives outside the component tree.
 */
let locked = false;
const listeners = new Set<(value: boolean) => void>();

export function setExamLock(value: boolean): void {
  if (locked === value) return;
  locked = value;
  for (const listener of listeners) listener(value);
}

export const isExamLocked = (): boolean => locked;

export function onExamLockChange(listener: (value: boolean) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
